let resumeData = {
    "imagebaseurl":"",
    "name": "Dev Patel",
    "role": "Mechatronics and Artificial Intelligence Systems Engineer",
    "linkedinId":"dev-patel03",
    "roleDescription": "",
    "socialLinks":[
        {
          "name":"linkedin",
          "url":"https://www.linkedin.com/in/dev-patel03/",
          "className":"fa fa-linkedin"
        },
        {
          "name":"github",
          "url":"https://github.com/devpatel2003",
          "className":"fa fa-github"
        },
        {
          "name":"quote",
          "url":"https://www.goodreads.com/quotes/1306252-stay-hungry-stay-foolish-never-let-go-of-your-appetite",
          "className":"fa fa-rebel"
        }
      ],
    "address":"Brampton, Ontario, Canada",
    "email":"devsp2003@gmail.com",
    "education":[
      {
        "UniversityName":"The University of Western Ontario",
        "specialization":"Mechatronics and Artificial Intelligence Systems Engineering",
        "MonthOfPassing":"May",
        "YearOfPassing":"2026",
        "Achievements":" Data Structure and Algorithm for Object-Oriented Design, Database Systems, Intro to Machine Learning, Statistics, Dynamics, Mechanics of Materials, Thermodynamics, Calculus 5, Circuits and Instrumentations"
      },
     
    ],
   "work":[
      {
        "CompanyName":"Western University, Dr. Pooja Viswanathan",
        "specialization":"Undergraduate Research Student",
        "MonthOfLeaving":"May - Aug",
        "YearOfLeaving":"2025",
        "Achievements":`• Developed and tested an autonomous wheelchair docking system, training Reinforcement Learning policies for safe approach and alignment using real wheelchair kinematics, sensor constraints, and collision-safety limits.\n
        • Trained autonomous navigation agents in PyBullet using PPO, SAC, and TD3, incorporating IMU and LiDAR observations with realistic hardware effects (wheel slip, actuator lag, LiDAR sampling characteristics) and domain randomization.\n
        • Explored a memory-aware exploration system in Isaac Sim/Lab using a Transformer-based architecture and Recurrent PPO, enabling the robot to navigate toward unknown goal locations using camera input (YOLO object detection), avoid backtracking, and build internal scene memory.\n
        • Deployed trained policies onto a ROS2 robotic car, writing ROS2 nodes to interface with onboard sensors and publish motion commands for real-world testing.`
      },
      {
        "CompanyName":"RBC , Wealth Management",
        "specialization":"Machine Learning Intern",
        "MonthOfLeaving":"May - Aug",
        "YearOfLeaving":"2024",
        "Achievements":`• Developed a proof-of-concept NLP tool designed to generate summarization reports of meeting notes for Investment Advisors, aimed at capturing key insights from the past 30 days and identifying notes beyond that window relevant to current needs.\n
          
        • Utilized Polars, NumPy and Matplotlib for data manipulation and visualization, while leveraging ML libraries like scikit-learn, PyTorch, TensorFlow, and AWS SageMaker for model training and deployment.\n
        • Pre-processed unstructured text data, improving dataset quality and reducing noise through the implementation of multiple tested solutions for cleaning and structuring mixed-quality notes.\n
        • Created a pair-wise comparison model to identify similar sentences but found it computationally expensive; instead, implemented PCA and clustering techniques to group similar sentences efficiently.\n
        • Developed a custom BERTopic model on a 50GB domain-specific dataset to categorize topics, enabling filtering of unnecessary information, and allowing for more insight into the dataset.\n
        • Experimented with fine-tuning pre-trained summarization models from Hugging Face for potential optimization.\n
        • Presented a comprehensive report detailing dataset challenges, various ML filtering solutions, and a strategic plan for integrating the summarization tool with RBC’s data management system.`
      },
      {
        "CompanyName":"CIBC",
        "specialization":"Co-op Applications Developer", 
        "MonthOfLeaving":"May - Aug",
        "YearOfLeaving":"2022",
        "Achievements":"Developed various proof of concepts including, web applications developed with Node.js, React, Express, and API microservices built using the Light-4j framework, PostgreSQL databases, and tested APIs with Postman "
      }
    ],
    
    "portfolio":[
      {
        "name":"Homelab: Self-Hosted Infrastructure & Local AI",
        "description":"",
        "imgurl":"images/portfolio/homelab.jpg",
        "modalType": "modalType7"
      },
      {
        "name":"Autonomous Wheelchair Navigation Using RL",
        "description":"",
        "imgurl":"images/portfolio/RLSchem.png",
        "modalType": "modalType6"
      },
      {
        "name":"WeMARS Rover Team",
        "description":"",
        "imgurl":"images/portfolio/RoverCover.jpg",
        "modalType": "modalType3"
      },
      {
        "name":"Recession Prediction Model",
        "description":"",
        "imgurl":"images/portfolio/StockCover.jpg",
        "modalType": "modalType2"
      },
      {
        "name":"Breast Cancer Prediction Model",
        "description":"",  
        "imgurl":"images/portfolio/BCcover.png",
        "modalType": "modalType1"
      },
  
      {
        "name":"8bit-Computer",
        "description":"",
        "imgurl":"images/portfolio/8bitCover.png",
        "modalType": "modalType4"
      },

      {
        "name":"Atari RL Agent",
        "description":"",
        "imgurl":"images/portfolio/Galaxian.png",
        "modalType": "modalType5"
      },
      
    ],
    
  }
  
  export default resumeData